module.exports = __webpack_public_path__ + "static/media/file-times-alt.19ff69a9.svg";